import React, { useState } from 'react';
import classNames from 'classnames';
import NumberBoxInput from "../NumberBoxInput";
import FormInputError from "../FormInputError";

interface GradeScoreInputProps {
    className?: string;
    grade?: string;
    minScore?: number;
    maxScore?: number;
    comment?: string;
    onMinScoreChange?: (value: any) => void;
    onMaxScoreChange?: (value: any) => void;
    onCommentChange?: (value: string) => void;
    errorMessage?: string | null;
    [key: string]: any;
}

function GradeScoreInput({
    className,
    grade = 'A',
    minScore = 0,
    maxScore = 100,
    comment = '',
    onMinScoreChange = () => {},
    onMaxScoreChange = () => {},
    onCommentChange = () => {},
    errorMessage = null,
    ...props
}: GradeScoreInputProps) {
    const classes = classNames(
        className,
        'd-flex',
        'align-items-center'
    );
    const [scores, setScores] = useState({
        min_score: minScore,
        max_score: maxScore,
    });
    const [commentText, setCommentText] = useState(comment);

    const handleMinScoreChange = (value: number) => {
        setScores({ ...scores, min_score: value });
        onMinScoreChange(value); // Notify parent
    };

    const handleMaxScoreChange = (value: number) => {
        setScores({ ...scores, max_score: value });
        onMaxScoreChange(value); // Notify parent
    };

    const handleCommentChange = (value: string) => {
        setCommentText(value);
        onCommentChange(value); // Notify parent
    };

    return (
        <>
            <div className={classes}>
                <div className='font-bold'>
                    {grade}
                </div>
                <div className='mx-3 d-flex align-items-center'>
                    <NumberBoxInput initialValue={scores.min_score} onValueChange={handleMinScoreChange} />
                    <span className='mx-2'> - </span>
                    <NumberBoxInput initialValue={scores.max_score} onValueChange={handleMaxScoreChange} />
                </div>

                {
                    errorMessage &&
                    <FormInputError>{errorMessage}</FormInputError>
                }
            </div>
            <div className='mt-2 ms-4'>
                <input
                    type='text'
                    className='form-control font-sm'
                    placeholder='Comment (e.g., "Excellent performance")'
                    value={commentText}
                    onChange={(e) => handleCommentChange(e.target.value)}
                    style={{ maxWidth: '400px' }}
                />
            </div>
        </>
    );
}

export default GradeScoreInput;
